module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.area) ? _c('div', {
    staticClass: "area"
  }, _vm._l((_vm.langs), function(lang) {
    return _c('textarea', {
      key: lang.id,
      attrs: {
        "type": "text",
        "placeholder": lang.label
      },
      domProps: {
        "value": _vm.value[lang.value]
      },
      on: {
        "blur": function (e) { return _vm.updateLang(lang.value, e.target.value); }
      }
    })
  })) : _c('div', _vm._l((_vm.langs), function(lang) {
    return _c('input', {
      key: lang.id,
      attrs: {
        "type": "text",
        "placeholder": lang.label
      },
      domProps: {
        "value": _vm.value[lang.value]
      },
      on: {
        "blur": function (e) { return _vm.updateLang(lang.value, e.target.value); }
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ccd4454","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/components/translation-input.vue
// module id = 3308
// module chunks = 0